import React from 'react';
import BookIcon from '@assets/icons/book-outline.svg';
import DocumentIcon from '@assets/icons/document.svg';
import DocumentTextIcon from '@assets/icons/document-text-outline.svg';
import BarnchIcon from '@assets/icons/git-branch-outline.svg';
import HelpIcon from '@assets/icons/help-circle-outline.svg';
import ServerIcon from '@assets/icons/server-outline.svg';
import SettingsIcon from '@assets/icons/settings-outline.svg';
import AdminIcon from '@assets/icons/shield-checkmark-outline.svg';
import AskIcon from '@assets/icons/sider-ask-icon.svg';
import PerformIcon from '@assets/icons/sider-perform-icon.svg';
import TrendingIcon from '@assets/icons/trending-up-outline.svg';
import { ADMIN_ROLES, ALLOWED_ROLES, ROLES } from '@constants/roles.ts';
import { getSidebarKeys } from '@layouts/main/sider/helpers.ts';
import { ROUTES } from '@router/constants.ts';
import { getAdminCenterContextFromToken } from '@routes/auth/___shared___/helpers.ts';
import { getAdminLandingPath } from '@utils/roles.ts';

export interface SidebarNavigationItem {
    title: string;
    key: string;
    url?: string;
    children?: SidebarNavigationItem[];
    icon?: React.ReactNode;
    role?: string[];
    disabled?: boolean;
}

// needs to be a hook to use useLingui() safely
// TODO add URLs from const or var from server
const ADMIN_VIEW_ROLES = [
    ...ADMIN_ROLES,
    ROLES.FLEET_DASHBOARD_VIEWER,
    ROLES.VESSEL_DASHBOARD_VIEWER,
    ROLES.CREW_ASSESSOR,
    ROLES.OFFICE_ASSESSOR,
];

export const useSidebarNavigation = (userRoles: string[]): SidebarNavigationItem[] => {
    const SIDEBAR_KEYS = getSidebarKeys();

    const adminLandingPath = getAdminLandingPath({ userRoles, ...getAdminCenterContextFromToken() });

    return [
        {
            title: SIDEBAR_KEYS.ASSESSMENT,
            key: SIDEBAR_KEYS.ASSESSMENT,
            url: `${ROUTES.SIDEBAR.ASSESSMENT} `,
            icon: <DocumentIcon />,
            role: ALLOWED_ROLES,
            disabled: true,
        },
        {
            title: SIDEBAR_KEYS.LEARNING,
            key: SIDEBAR_KEYS.LEARNING,
            url: `${ROUTES.SIDEBAR.LEARNING}`,
            icon: <BookIcon />,
            role: ALLOWED_ROLES,
        },
        {
            title: SIDEBAR_KEYS.PROGRESS,
            key: SIDEBAR_KEYS.PROGRESS,
            url: `${ROUTES.HOME}`,
            icon: <TrendingIcon />,
            role: ALLOWED_ROLES,
        },
        {
            title: SIDEBAR_KEYS.SURVEY,
            key: SIDEBAR_KEYS.SURVEY,
            url: `${ROUTES.HOME}`,
            icon: <DocumentTextIcon />,
            role: ALLOWED_ROLES,
        },
        {
            title: SIDEBAR_KEYS.ELEMENTS,
            key: SIDEBAR_KEYS.ELEMENTS,
            url: `${ROUTES.HOME}`,
            icon: <ServerIcon />,
            role: ALLOWED_ROLES,
        },
        {
            title: SIDEBAR_KEYS.PATHWAYS,
            key: SIDEBAR_KEYS.PATHWAYS,
            url: `${ROUTES.HOME}`,
            icon: <BarnchIcon />,
            role: ALLOWED_ROLES,
        },
        {
            title: SIDEBAR_KEYS.ADMIN,
            key: SIDEBAR_KEYS.ADMIN,
            url: adminLandingPath,
            icon: <AdminIcon />,
            role: ADMIN_VIEW_ROLES,
        },
        {
            title: SIDEBAR_KEYS.SETTINGS,
            key: SIDEBAR_KEYS.SETTINGS,
            url: `${ROUTES.SIDEBAR.SETTINGS}`,
            icon: <SettingsIcon />,
            role: ALLOWED_ROLES,
        },
        {
            title: SIDEBAR_KEYS.HELP_CENTER,
            key: SIDEBAR_KEYS.HELP_CENTER,
            url: `${ROUTES.SIDEBAR.HELP_CENTER}`,
            icon: <HelpIcon />,
            role: ALLOWED_ROLES,
            disabled: true,
        },
        {
            title: SIDEBAR_KEYS.ASK,
            key: SIDEBAR_KEYS.ASK,
            url: `${ROUTES.SIDEBAR.ASK} `,
            icon: <AskIcon />,
            role: ALLOWED_ROLES,
            disabled: true,
        },
        {
            title: SIDEBAR_KEYS.PERFORM,
            key: SIDEBAR_KEYS.PERFORM,
            url: `${ROUTES.SIDEBAR.PERFORM} `,
            icon: <PerformIcon />,
            role: ALLOWED_ROLES,
            disabled: true,
        },
    ];
};
